module.exports = __webpack_public_path__ + "static/media/Whiteboard with plants.e5167373.svg";